document.addEventListener('DOMContentLoaded', function() {
    // Simple script to update variant details when variant changes
    const form = document.querySelector('form[action*="/cart/add"]');
    const variantDetails = document.querySelectorAll('.variant-detail-content');
    
    if (form) {
      form.addEventListener('change', updateDetails);
      document.addEventListener('variant:change', updateDetails);
    }
    
    function updateDetails() {
      setTimeout(function() {
        // Get selected variant ID
        const input = document.querySelector('input[name="id"][type="hidden"], select[name="id"]');
        if (!input) return;
        
        const selectedId = input.value;
        
        // Show the matching variant details
        variantDetails.forEach(function(detail) {
          detail.style.display = (detail.dataset.variantId === selectedId) ? 'block' : 'none';
        });
      }, 50);
    }
  });


document.addEventListener('DOMContentLoaded', function() {
    // Script to update style tips when variant changes
    const form = document.querySelector('form[action*="/cart/add"]');
    const styleTips = document.querySelectorAll('.style-tip-content');
    
    if (form && styleTips.length > 0) {
      // Listen for changes on the form
      form.addEventListener('change', updateStyleTips);
      
      // Listen for Shopify's variant:change event
      document.addEventListener('variant:change', updateStyleTips);
    }
    
    function updateStyleTips() {
      setTimeout(function() {
        // Get selected variant ID
        const input = document.querySelector('input[name="id"][type="hidden"], select[name="id"]');
        if (!input) return;
        
        const selectedId = input.value;
        
        // Show the matching style tip
        styleTips.forEach(function(tip) {
          tip.style.display = (tip.dataset.variantId === selectedId) ? 'block' : 'none';
        });
      }, 50);
    }
  });